export default function (node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node // node is a Window
  || node.defaultView; // node is a Document
}